<template>
  <div class="import-wrapper">
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <el-table
      :data="tableData"
      border
      highlight-current-row
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        v-for="item of tableHeader"
        :key="item.propId"
        :prop="item.propId"
        width="200"
        :label="item.propName"
      >
        <template slot-scope="scope">
          <el-input
            v-if="item.propId === 'name'"
            v-model="scope.row.name"
            style="width: 100%"
            placeholder="请填写姓名"
            clearable
            :disabled="submitting"
          ></el-input>
          <el-input
            v-else-if="item.propId === 'telephoneNo'"
            v-model="scope.row.telephoneNo"
            style="width: 100%"
            placeholder="请填写手机"
            :disabled="submitting"
          ></el-input>
          <el-input
            v-else-if="item.propId === 'companyName'"
            v-model="scope.row.companyName"
            style="width: 100%"
            placeholder="请填写公司名称"
            :disabled="submitting"
            clearable
          ></el-input>
           <el-select
            v-else-if="item.propId === 'brandId'"
            style="width: 100%"
            v-model="scope.row.brandId"
            placeholder="请选择"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in brandOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <!-- <el-input
            v-else-if="item.propId === 'brandName'"
            v-model="scope.row.brandName"
            style="width: 100%"
            placeholder="请填写目前经营品牌"
            clearable
            :disabled="submitting"
          ></el-input> -->
          <!-- <el-input
            v-else-if="item.propId === 'country'"
            v-model="scope.row.country"
            style="width: 100%"
            placeholder="请填写国家"
            clearable
          ></el-input> -->
          <el-input
            v-else-if="item.propId === 'province'"
            v-model="scope.row.province"
            style="width: 100%"
            placeholder="请填写省份"
            :disabled="submitting"
            clearable
          ></el-input>
          <el-input
            v-else-if="item.propId === 'city'"
            v-model="scope.row.city"
            style="width: 100%"
            placeholder="请填写城市"
            :disabled="submitting"
            clearable
          ></el-input>
          <el-select
            v-else-if="item.propId === 'typeId'"
            style="width: 100%"
            v-model="scope.row.typeId"
            placeholder="请选择类型"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in merchantTypesOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'companyTypeId'"
            style="width: 100%"
            v-model="scope.row.companyTypeId"
            placeholder="请选择公司类型"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in companyOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'followUpStatusId'"
            style="width: 100%"
            v-model="scope.row.followUpStatusId"
            placeholder="请选择跟进状态"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in followUpStatusOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'ownerId'"
            style="width: 100%"
            v-model="scope.row.ownerId"
            placeholder="请选择跟进人"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in ownersOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'sourceId'"
            style="width: 100%"
            v-model="scope.row.sourceId"
            placeholder="请选择途径"
            clearable
            filterable
            :disabled="submitting"
          >
            <el-option
              v-for="item in sourceOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'promotionCompanyId'"
            style="width: 100%"
            v-model="scope.row.promotionCompanyId"
            placeholder="请选择线索"
            filterable
            clearable
            :disabled="submitting"
          >
            <el-option
              v-for="item in promotionCompanyOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="item.propId === 'stageId'"
            style="width: 100%"
            v-model="scope.row.stageId"
            placeholder="请选择阶段"
            filterable
            clearable
            :disabled="submitting"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.id + item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span v-else>{{ scope.row[item.propId] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tableData.length > 0"
        prop="control"
        align="center"
        label="提交状态"
        width="80"
        fixed="right"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.statusText">暂无</span>
          <span v-else :class="{
            'text-success': scope.row.statusCode === 200,
            'text-danger' : scope.row.statusCode === 400
          }">{{
            scope.row.submitting ? "提交中..." : scope.row.statusText
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tableData.length > 0"
        prop="control"
        align="center"
        label="操作"
        width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            class="control-btn"
            size="small"
            v-if="scope.row.statusCode && scope.row.statusCode === 400"
            @click="rePost(scope.row, scope.$index)"
            >重试</el-button
          >
          <el-button
            type="text"
            class="control-btn"
            size="small"
            @click="deleteRow(scope.row, scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div :style="{ textAlign: 'right', padding: '10px 0' }">
      <el-button type="primary" @click="postAllFormItem" :loading="submitting"
        >提交新增</el-button
      >
      <el-button @click="cancelPost" :loading="submitting">关 闭</el-button>
    </div>
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import formSelection from "../mixins/formSelection.js";
import { isEmprty, isPhone } from "@/utils/validate";
export default {
  components: { UploadExcelComponent },
  mixins: [formSelection],
  props:{
    isSelfDevelop:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      tableData: [],
      tableHeader: [],
      formData: [],
    };
  },
  methods: {
    isEmprty,
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "上传的文件不能大于1M",
        type: "warning",
      });
      return false;
    },
    handleSuccess({ results, header }) {
      let formatData = [];
      let tempTableHeader = [];
      results.forEach((item) => {
        let tempObj = {
          brandName: "",
          city: "",
          companyName: "",
          country: "中国",
          name: "",
          province: "",
          sourceId: 3,
          telephoneNo: "",
          typeId: 1,
          promotionCompanyId: 1,
          companyTypeId: null,
          followUpStatusId: null,
          ownerId: null,
          stageId: null,
          brandId: null,
          selfDevelop: this.isSelfDevelop
        };
        for (const key in item) {
          tempObj[this.getObjKey(key)] = this.getObjValue(
            this.getObjKey(key),
            item[key]
          );
        }
        formatData.push(tempObj);
      });
      tempTableHeader = header.map((item) => {
        return {
          propName: item,
          propId: this.getObjKey(item),
        };
      });
      this.tableHeader = tempTableHeader;
      this.tableData = formatData;
    },
    // 读取出来的excel的键名都是中文的，所以需要把键名换成对应的字段名
    getObjKey(keyname = "") {
      switch (keyname) {
        case "类型":
          return "typeId";
          break;
        case "姓名":
          return "name";
          break;
        case "手机":
          return "telephoneNo";
          break;
        case "国家":
          return "country";
          break;
        case "省份":
          return "province";
          break;
        case "城市":
          return "city";
          break;
        case "公司名称":
          return "companyName";
          break;
        case "公司类型":
          return "companyTypeId";
          break;
        case "目前经营品牌":
          return "brandId";
          break;
        case "跟进状态":
          return "followUpStatusId";
          break;
        case "跟进人":
          return "ownerId";
          break;
        case "途径":
          return "sourceId";
          break;
        case "线索":
          return "promotionCompanyId";
          break;
        case "阶段":
          return "stageId";
          break;

        default:
          break;
      }
    },
    // 拿回来的数据都是文本状态的，有些字段需要匹配选单中的对应的id才能回传
    getObjValue(keyname = "", value = "") {
      let target = null;
      switch (keyname) {
        case "typeId":
          target = this.merchantTypesOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;
        case "name":
          return value;
          break;
        case "telephoneNo":
          return value;
          break;
        case "country":
          return value;
          break;
        case "province":
          return value;
          break;
        case "city":
          return value;
          break;
        case "companyName":
          return value;
          break;
        case "companyTypeId":
          target = this.companyOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;
        case "brandId":
           target = this.brandOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;
        case "followUpStatusId":
          target = this.followUpStatusOptions.find(
            (item) => item.name == value
          );
          return target ? target.id : null;
          break;
        case "ownerId":
          target = this.ownersOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;
        case "sourceId":
          target = this.sourceOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;
        case "promotionCompanyId":
          target = this.promotionCompanyOptions.find(
            (item) => item.name == value
          );
          return target ? target.id : null;
          break;
        case "stageId":
          target = this.stateOptions.find((item) => item.name == value);
          return target ? target.id : null;
          break;

        default:
          break;
      }
    },
    // onTypeChange(item) {
    //   if (item) {
    //     // 非经销商类型下要清空经营品牌的内容
    //     if (item.typeId !== 1) {
    //       item.brandName = "";
    //     }
    //     // 私宅业主类型下需要清空公司名称
    //     if (item.typeId === 7) {
    //       item.companyName = "";
    //     }
    //     // 非项目合作的类型需要把公司类型设置为空
    //     if (item.typeId !== 3) {
    //       item.companyTypeId = null;
    //     }
    //   }
    // },
    // 验证每一项表单
    validateFormItem(item, index) {
      if (isEmprty(item.typeId)) {
        this.$message.error(`请选择第${index + 1}行数据的类型`);
        return false;
      }
      if (isEmprty(item.name)) {
        this.$message.error(`请填写第${index + 1}行数据的名字`);
        return false;
      }
      if (isEmprty(item.telephoneNo)) {
        this.$message.error(`请填写第${index + 1}行数据的电话号码`);
        return false;
      }
      if (!isPhone(item.telephoneNo)) {
        this.$message.error(`第${index + 1}行数据的手机号码不正确`);
        return false;
      }
      //   if (this.isPhoneRepeat) {
      //     this.$message.error("该手机号码已存在");
      //     return false;
      //   }
      if (isEmprty(item.province) || isEmprty(item.city)) {
        this.$message.error(
          `第${
            index + 1
          }行数据的省份和城市不能为空，并且格式只能为【佛山】 ，不能填 【佛山市】`
        );
        return false;
      }
      if(this.isSelfDevelop){
        if (isEmprty(item.brandId)) {
          this.$message.error(`请填写第${index + 1}行数据的目前经营的品牌`);
          return false;
        }
      }

      // 除了私宅业主类型外都要验证公司名称
      // if (item.typeId !== 7) {
      //   if (isEmprty(item.companyName)) {
      //     this.$message.error(`请填写第${index + 1}行数据的公司名称`);
      //     return false;
      //   }
      // }

      // // 经销商类型下需要验证经营的品牌
      // if (item.typeId === 1) {
      //   if (isEmprty(item.brandId)) {
      //     this.$message.error(`请填写第${index + 1}行数据的您目前经营的品牌`);
      //     return false;
      //   }
      // }
      // // 项目合作下需要验证公司类型
      // if (item.typeId === 3) {
      //   if (isEmprty(item.companyTypeId)) {
      //     this.$message.error(`请选择第${index + 1}行数据的公司类型`);
      //     return false;
      //   }
      // }
      return true;
    },
    resetItemData(item) {
      // 非经销商类型下要清空经营品牌的内容
      if (item.typeId !== 1) {
        item.brandId = null;
      }
      // 私宅业主类型下需要清空公司名称
      if (item.typeId === 7) {
        item.companyName = "";
      }
      // 非项目合作的类型需要把公司类型设置为空
      if (item.typeId !== 3) {
        item.companyTypeId = null;
      }
      return item;
    },
    postAllFormItem() {
      // 数据行验证
      if (this.tableData.length <= 0) {
        this.$message.error("提交的数据不能为空!");
        return false;
      }
      //   数据行的字段验证
      let isPass = true;
      for (let i = 0; i < this.tableData.length; i++) {
        if (!this.validateFormItem(this.tableData[i], i)) {
          isPass = false;
          break;
        }
      }
      if (isPass) {
        this.tableData = this.tableData.map((item) => {
          return {
            // ...this.resetItemData(item),
            ...item,
            submitting: false,
            statusCode: null,
            statusText: "待提交",
          };
        });
        this.submitting = true;
        //   提交
        this.tableData.forEach((item) => {
          this.onPostItem(item);
        });
        this.checkSubmitStatus();
      }
    },
    onPostItem(params) {
      params.submitting = true;
      let formData = JSON.parse(JSON.stringify(params));
      delete formData.submitting;
      delete formData.statusCode;
      delete formData.statusText;
      this.$api
        .post(`/merchants`, formData)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            params.submitting = false;
            params.statusCode = 200;
            params.statusText = "添加成功";
          }
        })
        .catch((err) => {
          params.statusCode = 400;
          params.statusText = err.message;
          params.submitting = false;
        });
    },
    checkSubmitStatus() {
      let timer = null;
      timer = setInterval(() => {
        const allDone = this.tableData.every(
          (item) => item.statusCode !== null
        );
        this.allSubmitDone = allDone;
        // 检查是否全部提交，无论是否成功
        if (allDone) {
            // 检查是否全部提交成功
          const allSubmitSuccess = this.tableData.every(
            (item) => item.statusCode === 200
          );
          if (allSubmitSuccess) {
            this.tableData = [];
            this.tableHeader = [];
            this.$message.success("全部提交成功!");
          }
          this.submitting = false;
          clearInterval(timer);
        }
      }, 800);
    },
    rePost(row, index) {
      row.submitting = false;
      row.statusCode = "";
      row.statusText = "";
      this.onPostItem(row);
      this.checkSubmitStatus();
    },
    cancelPost() {
      // 如果没有数据，就直接关闭
      if(this.tableData.length <= 0 && this.tableHeader.length <= 0){
        this.$emit("cancel");
        return false
      }
      this.$confirm(
        "关闭弹窗将会清空表单，如果已经确认提交状态，点击确定即可关闭弹窗",
        "是否确认关闭弹窗？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.tableData = [];
          this.tableHeader = [];
          this.$emit("cancel");
        })
        .catch(() => {});
    },
    deleteRow(row, index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>